module.exports = __webpack_public_path__ + "img/icon-round-delete.e5de5f34.svg";